import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

const useScreenSize = () => {
  const theme = useTheme();

  const isMobile = useMediaQuery(theme.breakpoints.down("sm")); // < 481px
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md")); // 481px - 1024px
  const isStandard = useMediaQuery(theme.breakpoints.between("md", "lg")); // 1025px - 1440px
  const isMonitor = useMediaQuery(theme.breakpoints.up("lg")); // > 1440px

  return { isMobile, isTablet, isStandard, isMonitor };
};

export default useScreenSize;
